import React, { useEffect } from 'react';
import './App.css';
import { Analytics } from '@vercel/analytics/react';
import Home from './Containers/Home/Home';
import ProjectCarousel from './Components/ProjectCarousel/ProjectCarousel';
import Brands from './Containers/Brands/Brands';
import Portfolio from './Containers/Portfolio/Portfolio';
import Recommendations from './Containers/Recommendations/Recommendations';
import Contact from './Containers/Contact/Contact';
import Footer from './Containers/Footer/Footer';
import Media from './Containers/Media/Media';
import Achievements from './Containers/Achievements/Achievements'
import { initRevealOnScroll } from './utils/reveal';
import NavBar from './Containers/NavBar/NavBar';

function App() {
	useEffect(() => {
    const dispose = initRevealOnScroll();
    return () => dispose && dispose();
  }, []);
	return (
		<div className="App">
			<Analytics />
			<div className="App-Content">
				<NavBar />
				<Home />
				<ProjectCarousel />
				<Brands />
				<Portfolio />
				<Recommendations />
				<Media />
				<Achievements />
				<Contact />
				<Footer />
			</div>
		</div>
	);
}

export default App;
